import { createFileRoute } from "@tanstack/react-router";
import TitleBar from "@/components/layout/TitleBar";
import PageContent from "@/components/PageContent";

export const Route = createFileRoute('/testing-events')({
  component: TestEvents,
})

function TestEvents() {
  return (
    <>
      <TitleBar />
      <PageContent>
        <section className="my-4">
          <h1>Testing Events</h1>
          <p>This page shows upcoming test events (locations and dates) by state/province. Use the drop-down menu to select your location, and the test events for that locality will load.</p>
          <p className="mb-4"><em className="font-bold">Please note</em>: This page is informational only. To register, begin by logging in at the <a href="https://register.evtcc.org">registration portal</a>.</p>
        </section>
        <iframe title="Test Sites Data Table" src="https://evtcertificationcommission-external.cloud.alphasoftware.com/public_testsites.a5w" className="w-full h-120 md:h-200 border-gray-300 border mb-8"></iframe>
      </PageContent>
    </>
  )
}
